import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h2 {
    font-size: 24px; 
    color: #2863d0;
    text-transform: uppercase;
    margin-top: 0;
  }

  p {
    font-size: 17px;
    line-height: 23px;
    span {
      color: #2863d0;
    }

    span {
      color: #F21111;
    }
  }
`;
